"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.camelCase = exports.capitalize = void 0;

var capitalize = function capitalize(word) {
  return word.split('').map(function (letter, index) {
    return index ? letter.toLowerCase() : letter.toUpperCase();
  }).join('');
};

exports.capitalize = capitalize;

var camelCase = function camelCase(text) {
  if (text !== 'unknown') {
    var regex = /[^a-z0-9]|\s+|\r?\n|\r/gmi;
    return text.split(regex).map(function (word, index) {
      return index ? exports.capitalize(word) : word.toLowerCase();
    }).join('');
  } else {
    return '';
  }
};

exports.camelCase = camelCase;